
<button mat-mini-fab (click)="onClick.emit()">
  <mat-icon>{{icon}}</mat-icon>
</button>
